export default {
  AGENT_CATEGORY: 'Comercial:',

  // 404 page
  PAGE_404_TITLE: 'Erro 404 página não encontrada',
  PAGE_404_DESCRIPTION: 'Não foi possível encontrar a página que procura, pedimos desculpa',
  PAGE_404_BUTTON: 'Sair da aplicação',

  // 401 page
  PAGE_401_TITLE: 'Erro 401 não autorizado',
  PAGE_401_DESCRIPTION: 'Não está autorizado a aceder a esta página',
  PAGE_401_BUTTON: 'Sair da aplicação',

  // ADMIN
  ADMIN_HOME_TITLE: 'Bem-vindo à administração do Minerva',
  ADMIN_HOME_TEXT:
    'A partir daqui, através do menu lateral, pode criar e editar ofertas e carregar novos modelos tarifários.',
  ADMIN_TABLE_RESULTS_PER_PAGE: 'Resultados por página',
  ADMIN_TABLE_NO_RESULTS: 'Não há dados para mostrar',
  ADMIN_UPDATE: 'Atualizar',
  ADMIN_CANCEL: 'Cancelar',
  ADMIN_CONTINUE: 'Continuar',
  ADMIN_CONFIRM: 'Confirmar',
  ADMIN_TABLE_HEADER_ACTIONS: 'Ações',
  ADMIN_ALERT_TEXT: 'Ocorreu um erro ao realizar a operação',
  ADMIN_OFFERS_MODAL_EDIT_TITLE: 'Tem a certeza de que pretende editar a oferta?',
  ADMIN_OFFERS_CREATE_BUTTON: 'Criar oferta (ES)',
  ADMIN_OFFERS_CREATE_BUTTON_PT: 'Criar oferta (PT)',
  ADMIN_OFFERS_TABLE_HEADER_ID: 'ID da oferta',
  ADMIN_OFFERS_TABLE_HEADER_TYPE: 'Tipo',
  ADMIN_OFFERS_TABLE_HEADER_STATUS: 'Estado da oferta',
  ADMIN_OFFERS_TABLE_HEADER_VALIDATION_STATUS: 'Estado de validação',
  ADMIN_OFFERS_TABLE_HEADER_COMMERCIAL: 'Comercial',
  ADMIN_OFFERS_TABLE_HEADER_CREATION_DATE: 'Data de criação',
  ADMIN_RATE_MODELS_TABLE_HEADER_ID: 'ID do modelo',
  ADMIN_RATE_MODELS_TABLE_HEADER_DESCRIPTION: 'Descrição',
  ADMIN_RATE_MODELS_UPLOAD_BUTTON: 'Carregar novo modelo',
  ADMIN_RATE_MODELS_MODAL_TITLE: 'Novo modelo tarifário',
  ADMIN_TRANSLATIONS_ADD_BUTTON: 'Adicionar tradução',
  ADMIN_TRANSLATIONS_MODAL_CREATE_TITLE: 'Adicionar tradução',
  ADMIN_TRANSLATIONS_MODAL_EDIT_TITLE: 'Editar tradução',
  ADMIN_TRANSLATIONS_MODAL_DELETE_TITLE: 'Tem a certeza de que pretende eliminar esta tradução?',
  ADMIN_TRANSLATIONS_TABLE_HEADER_KEY: 'Chave',
  ADMIN_TRANSLATIONS_TABLE_HEADER_VALUE: 'Valor',
  ADMIN_TRANSLATIONS_FORM_KEY_FORMAT_ERROR:
    'A chave só pode conter letras maiúsculas, números e underscores (_) e deve começar por uma letra',

  // MAIN HEADER
  MENU_SECTION_HOME: 'Home',
  MENU_SECTION_OFFERS: 'Ofertas',
  MENU_SECTION_RATE_MODELS: 'Modelos tarifários',
  MENU_SECTION_TRANSLATIONS: 'Traduções',

  // STEPPER
  STEPPER_BUTTON_BEFORE: 'Anterior',
  STEPPER_BUTTON_AFTER: 'Continuar',
  STEPPER_BUTTON_END: 'Finalizar',
  STEPPER_BUTTON_SIGN: 'Assinatura digital',
  STEPPER_BUTTON_MANUAL_SIGN: 'Assinatura manual',
  STEPPER_STEP1_LABEL: 'Produtos e portes',
  ADDITIONAL_SERV_LABEL: 'Serviços adicionais',
  STEPPER_STEP3_LABEL: 'Forma de pagamento',
  STEPPER_STEP4_LABEL: 'Detalhe dos volumes',
  STEPPER_STEP5_LABEL: 'Dispersão dos produtos',
  STEPPER_STEP6_LABEL: 'Assinatura do contrato',
  STEPPER_STEPINIT_TITLE: 'Selecionar um modelo tarifário',
  STEPPER_STEPINIT_FIELD: 'Modelo Tarifário',
  STEPPER_STEPINIT_LABEL: 'Modelo Tarifário',
  STEPPER_LEGAL_CITY_FIELD: 'Cidade jurídica',
  STEPPER_STEPINIT_ADDRESSES_LEAD: 'Pontos de serviço',
  STEPPER_STEPINIT_MAIN_ADDRESS: 'Principal',
  STEPPER_STEPINIT_ADDRESS: 'Morada',
  STEPPER_STEPINIT_SHIPPING_AMOUNT: 'Número de envios',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_EXCESS_ERROR:
    'Reveja o número de envios atribuído a cada ponto, atualmente excede {diff} envios. <br> O total não deve superar o número de envios comprometidos por mês ( {total} envios).',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_GAP_ERROR:
    'Reveja o número de envios atribuído a cada ponto, atualmente faltam {diff} envios. <br> O total não deve superar o número de envios comprometidos por mês ( {total} envios).',
  STEPPER_STEPINIT_FAVORITE_ERROR: 'Deve selecionar um Ponto de Serviço principal',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_VALIDATION_ERROR_NULL: 'Este campo é obrigatório',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_VALIDATION_ERROR_NEGATIVE:
    'O valor deve ser maior ou igual a zero',
  STEPPER_STEPINIT_SHIPPING_AMOUNT_VALIDATION_ERROR_FLOAT: 'O valor deve ser um número inteiro',
  STEPPER_STEPINIT_CLONE_OFFER_TITLE: 'Clonar oferta',
  STEPPER_STEPINIT_CLONE_OFFER_PLACEHOLDER: 'ID da oferta de origem',
  STEPPER_STEPINIT_CLONE_OFFER_BUTTON: 'Clonar oferta',
  STEPPER_STEPINIT_CLONE_OFFER_ERROR_404: 'Oferta de destino não encontrada',
  STEPPER_STEPINIT_CLONE_OFFER_ERROR_406:
    'O modelo tarifário da oferta de origem já não está ativo',
  STEPPER_STEPINIT_CLONE_OFFER_ERROR_409: 'A oferta de origem não existe',
  STEPPER_STEP1_H1: 'Selecionar os produtos a ofertar',
  STEPPER_STEP1_H1_READONLY: 'Produtos',
  STEPPER_STEP1_DESCRIPTION:
    'Selecionar os produtos a incluir na oferta. Os marcados como obrigatórios devem ser recomendados ao cliente.',
  STEPPER_STEP1_DESCRIPTION2:
    'O modelo de Venda Direta atual não tem nenhum produto marcado como obrigatório.',
  STEPPER_STEP1_H3: 'Produtos obrigatórios',
  TARIFF_STANDARD_24H: 'Ctt 24h - Ctt e24h',
  TARIFF_STANDARD_13H: 'Ctt 14:00h',
  TARIFF_STANDARD_10H: 'Ctt 10:00h',
  TARIFF_STANDARD_08H: 'Ctt 08:30h',
  TARIFF_STANDARD_48H: 'Ctt 48h - e48h',
  TARIFF_STANDARD_E24H: 'e24h (Para Amanhã; Devoluçao Fácil)',
  TARIFF_STANDARD_E48H: '48h (Em 2 Dias)',
  TARIFF_STANDARD_e24H: 'e24h (Para Amanhã; Devoluçao Fácil)',
  TARIFF_STANDARD_e48H: '48h (Em 2 Dias)',
  TARIFF_STANDARD_10H_PT: 'CTT 10h',
  TARIFF_STANDARD_13H_PT: 'CTT 14h',
  TARIFF_STANDARD_19H_19M: '24h / 24hM ( 19h / 19M )',
  TARIFF_STANDARD_24H_PT: 'CTT 24h',
  TARIFF_STANDARD_48H_PT: 'CTT 48h',
  TARIFF_STANDARD_E24H_PT: 'CTT e24h / Easy Return',
  TARIFF_STANDARD_E48H_PT: 'CTT e48h (Em 2 Dias)',
  TARIFF_STANDARD_PTE: 'Ilhas PT (Aéreo)',
  TARIFF_STANDARD_PTE_ACORES: 'Ilhas PT (Aéreo) - Açores',
  TARIFF_STANDARD_PTE_MADEIRA: 'Ilhas PT (Aéreo) - Madeira',
  TARIFF_STANDARD_PTM: 'Ilhas PT (Marítimo)',
  TARIFF_STANDARD_PTI: 'Interilhas PT',
  TARIFF_STANDARD_BALEXPRESS: 'CTT 24h (Baleares)',
  TARIFF_STANDARD_BALMARITIMO: 'CTT Marítimo (Baleares)',
  TARIFF_STANDARD_CANEXPRESS: 'CTT 24h (Canárias)',
  TARIFF_STANDARD_OTHERDESTINATIONS: 'Outros Destinos',
  OTHERDESTINATIONS: 'CTT Outros destinos',
  TARIFF_CANARY_13: 'Canarias 14:00h',
  TARIFF_CANARY_24: 'Canarias 24h',
  TARIFF_STANDARD_14H_PT: 'CTT 14h',
  TARIFF_STANDARD_PTIEXPRESS: 'CTT 24h (Ilhas PT)',
  TARIFF_STANDARD_PTIEXPRESS_RAA: 'CTT 24h (Ilhas PT) - Açores',
  TARIFF_STANDARD_PTIEXPRESS_LPMA: 'CTT 24h (Ilhas PT) - Madeira',
  TARIFF_STANDARD_PTIECONOMY: 'CTT Marítimo (Ilhas PT)',
  TARIFF_STANDARD_BALECONOMY: 'CTT Marítimo (Baleares)',
  TARIFF_STANDARD_CANECONOMY: 'CTT Marítimo (Canárias)',
  TARIFF_STANDARD_OTHERDESTINATIONS_PT: 'Outros Destinos',
  TARIFF_STANDARD_CCAR_PT: 'Carga',
  JSON_INTSTD: 'Internacional Economy',
  TARIFF_STANDARD_CIES: 'Internacional Economy',
  JSON_FRANCIA: 'França',
  JSON_ZONE1: 'Zona 1',
  ZONE_1: 'Zona 1',
  JSON_ZONE2: 'Zona 2',
  ZONE_2: 'Zona 2',
  JSON_ZONE3: 'Zona 3',
  ZONE_3: 'Zona 3',
  JSON_ZONE4: 'Zona 4',
  ZONE_4: 'Zona 4',
  JSON_ZONE5: 'Zona 5',
  ZONE_5: 'Zona 5',
  JSON_ZONE6: 'Zona 6',
  ZONE_6: 'Zona 6',
  JSON_ZONE7: 'Zona 7',
  ZONE_7: 'Zona 7',
  JSON_ZONE8: 'Zona 8',
  ZONE_8: 'Zona 8',
  JSON_ZONE9: 'Zona 9',
  ZONE_9: 'Zona 9',
  JSON_ZONEA: 'Zona A',
  JSON_ZONEB: 'Zona B',
  JSON_ZONEC: 'Zona C',
  JSON_ZONED: 'Zona D',
  JSON_ZONEE: 'Zona E',
  JSON_ZONEF: 'Zona F',
  JSON_ZONEG: 'Zona G',
  JSON_ZONEH: 'Zona H',
  JSON_ZONEI: 'Zona I',
  JSON_ZONES: 'Zona S',
  JSON_ZONET: 'Zona T',
  JSON_ZONEU: 'Zona U',
  JSON_ZONEV: 'Zona V',
  JSON_ZONEW: 'Zona W',
  JSON_ZONEX: 'Zona X',
  JSON_ZONEY: 'Zona Y',
  TARIFF_CANARY_ECOMMERCE: 'CTT Canarias Aéreo 24H',
  TARIFF_STANDARD_CCA24: 'CTT Canarias Aéreo 24H',
  TARIFF_STANDARD_CCA48: 'CTT Canarias Aéreo 48H',
  TARIFF_CANARY_MARITIME: 'CTT Canarias Marítimo',
  TARIFF_BALEAR_13: 'Baleares 14:00h',
  TARIFF_BALEAR_24: 'Baleares 24h - e24h',
  TARIFF_BALEAR_48: 'Baleares 48h - e48h',
  JSON_INTEXP: 'CTT Internacional Express',
  JSON_INT_ECOMMERCE: 'CTT Internacional Ecommerce',
  JSON_INT_ELIGHT: 'CTT Internacional Europa Light',
  TARIFF_STANDARD_CIEL: 'CTT Internacional Europa Light',
  JSON_BALMAY: 'Maiorca',
  JSON_BALMEN: 'Resto das Ilhas',
  JSON_DE: 'Alemanha',
  JSON_UK: 'Reino Unido',
  JSON_IT: 'Itália',
  JSON_BE: 'Bélgica',
  JSON_NL: 'Holanda',
  JSON_LU: 'Luxemburgo',
  JSON_PORTUGAL: 'Portugal',
  JSON_TNFLPA: 'Tnf & Lpa',
  JSON_IMENORES: 'I. Menores',
  JSON_INTERI: 'Interilhas',
  JSON_MALLORCA: 'Maiorca',
  JSON_MADRID: 'Madrid',
  JSON_MADEIRA: 'Madeira',
  JSON_ACORES: 'Açores',
  JSON_MAIORCA: 'Maiorca',
  JSON_OUTRAS_ILHAS: 'Outras Ilhas',
  JSON_ILHA: 'Mesma Ilha',
  JSON_MARQUIPELAGO: 'Mesmo Arquipélago',
  JSON_EARQUIPELAGO: 'Entre Arquipélagos',
  JSON_INTERILHAS: 'Interilhas',
  JSON_ARQUIPELAGOS: 'Arquipélagos',
  STEPPER_STEP1_OPTIONAL: 'Opcionais',
  STEPPER_STEP1_OPTIONAL_SELECTALL: 'Selecionar todos',
  TARIFF_STEP_CHANGE_OFFER_TYPE_CANCEL: 'Voltar ao passo anterior',
  TARIFF_STEP_CHANGE_OFFER_TYPE_CONTINUE: 'Continuar',
  TARIFF_STEP_CHANGE_OFFER_TYPE_TITLE:
    'A oferta Tipo {offerType} necessita de mais informações de detalhe',
  TARIFF_STEP_CHANGE_OFFER_TYPE_DESC:
    'Para concluir a oferta do Tipo {offerType} são necessárias mais informações, serão solicitados os dados requeridos.',
  TARIFF_CHANGE_OFFER_TYPE_TITLE: 'Pretende continuar a conversão de oferta para Tipo A?',
  TARIFF_CHANGE_OFFER_TYPE_DESC:
    'A conversão da oferta para Tipo A reinicia todas as alterações efetuadas.',
  TARIFF_CHANGE_OFFER_TYPE_BUTTON_CONTINUE: 'Converter',
  TARIFF_CHANGE_OFFER_TYPE_BUTTON_CANCEL: 'Cancelar',

  // Sticky box
  STICKYBOX_TITLE: 'Dados do cliente',
  STICKYBOX_SOCIAL_REASON: 'Razão social',
  STICKYBOX_CIF: 'NIF',
  STICKYBOX_MONTH: 'MÊS',
  STICKYBOX_COMPROMISED: 'Envios comprometidos',
  STICKYBOX_INTERNATIONAL: 'Envios internacionais',
  STICKYBOX_SERVICE_POINT: 'Prov. ponto serviço',
  STICKYBOX_VALIDATION_TITLE: 'Dados da oferta',
  STICKYBOX_VALID_STATUS: 'Validade',
  STICKYBOX_APPROB_STATUS: 'Estado',
  STICKYBOX_OFFER_TYPE: 'Tipo',
  STICKYBOX_OFFER_VERSION: 'Versão',
  STICKYBOX_VALID: 'Válida',
  STICKYBOX_INVALID: 'Inválida',
  STICKYBOX_APPROVED: 'Aprovada',
  STICKYBOX_UNAPPROVED: 'Pendente de aprovação',
  STICKYBOX_VALIDATING: 'Em validação',
  STICKYBOX_REJECTED: 'Rejeitada',
  STICKYBOX_RETURNED: 'Devolvida',
  STICKYBOX_TYPEA: 'Tipo A',
  STICKYBOX_TYPEB: 'Tipo B',
  STICKYBOX_TYPEC: 'Tipo C',
  STICKYBOX_TYPEF: 'Tipo F',
  STICKYBOX_BUTTON_SAVE: 'Guardar oferta',
  STICKYBOX_BUTTON_CONVERTA: 'Converter Tipo A',
  STICKYBOX_BUTTON_CONVERTC: 'Converter Tipo C',
  STICKYBOX_BUTTON_UPDATE_OFFER_STATUS: 'Atualizar estado',
  STICKYBOX_BUTTON_RESET: 'Cancelar oferta',
  STICKYBOX_COPY_OFFERID: 'Copiar ID',
  STICKYBOX_BUTTON_VALIDATIONS_TURN_ON: 'Ativar validações',
  STICKYBOX_BUTTON_VALIDATIONS_TURN_OFF: 'Desativar validações',
  STICKYBOX_BUTTON_MAX_DISCOUNTS: 'Descontos MAX',
  STICKYBOX_BUTTON_RESET_DISCOUNTS: 'Redefinir descontos',

  // Sticky Sign
  STICKYSIGN_CONTRACT: 'Dados do contrato',
  // Alerts
  ALERT_ZONE_ERROR:
    'Os descontos do produto <b>{product}</b> não cumprem as validações de preços entre zonas.',
  ALERT_PRODUCT_ERROR:
    'Os descontos do produto <b>{product}</b> não cumprem as validações de preços entre produtos.',
  ALERT_ERROR_SERVICE: 'Serviço ',
  ALERT_TYPE_B_PRODUCT_PRICES:
    'Oferta do Tipo B devido aos descontos excederem o máximo permitido pela Empresa.',
  ALERT_TYPE_B_PRODUCT_WEIGHTS:
    'Oferta do Tipo B devido à modificação dos pesos padrão.',
  ALERT_TYPE_B_ADDITIONAL_SERVICES:
    'Oferta do Tipo B devido ao valor dos serviços adicionais requererem aprovação.',
  ALERT_TYPE_B_PAYMENT_METHODS:
    'Oferta do Tipo B devido ao método de pagamento requerer aprovação.',
  ALERT_TYPE_B_OPTY_SERVICE_POINTS:
    'Oferta do Tipo B porque contém mais de uma morada de recolha.',
  ALERT_TYPE_B_PRODUCTS:
    'Oferta do Tipo B devido à seleção de produtos opcionais.',
  ALERT_BUTTON_SHOW: 'Ver mais avisos',
  ALERT_BUTTON_HIDE: 'Ver menos avisos',
  ALERT_SHOW_DETAILS: 'Mostrar detalhes',
  ALERT_HIDE_DETAILS: 'Ocultar detalhes',
  ALERT_DETAILS_LABEL: 'Detalhes:',

  //Shipping
  SHIPPING_TITLE: 'Configura as percentagens de desconto e portes dos produtos',
  SHIPPING_SUBTITLE:
    'Configurar as percentagens de desconto aplicadas aos produtos selecionados para ajustar a oferta ao cliente. <b>Não recomendamos ultrapassar as percentagens máximas indicadas</b>',
  SHIPPING_ADDITIONAL_KG: 'Kg adicional',
  SHIPPING_DISCOUNTS_UNLOCK: 'Desbloquear descontos',
  SHIPPING_DISCOUNTS_LOCK: 'Bloquear descontos',
  SHIPPING_ADDED_ROW2_DISCOUNT: 'Desconto',
  SHIPPING_HEADERS_WEIGHT: 'Peso (kg)',
  JSON_PROVINCE: 'Provincial',
  JSON_REGION: 'Regional',
  JSON_PENINSULAR: 'Peninsular',
  JSON_PENINSULARPLUS: 'Peninsular+',
  JSON_CEUTA: 'Ceuta',
  JSON_MELILLA: 'Melilla',
  JSON_ANDORRA: 'Andorra',
  JSON_GIBRALTAR: 'Gibraltar',
  JSON_PTISLANDS: 'Ilhas Portugal',
  JSON_PTIAEREO: 'Ilhas Portugal Aéreo',
  JSON_PTIMARITIMO: 'Ilhas Portugal Marítimo',
  JSON_CANMAY: 'Lpa - Tnf',
  JSON_CANEXPRESS: 'CTT Canarias Documentación',
  JSON_BALEXPRESS: 'Baleares Express',
  JSON_BALECONOMY: 'Baleares Economy',
  PRICE_MODAL_TITLE: 'Modificar preço',
  PRICE_MODAL_CHANGE: 'Alterar',
  PRICE_MODAL_CANCEL: 'Cancelar',
  SHIPPING_MODAL_TITLE: 'Modificar número de envios',
  SHIPPING_MODAL_CHANGE: 'Alterar',
  SHIPPING_MODAL_CANCEL: 'Cancelar',
  SHIPPING_MODAL_ACTIONS_ADD: 'Confirmar',
  SHIPPING_MODAL_ACTIONS_DEFAULT_WEIGHTS: 'Selecionar pesos por defeito',
  SHIPPING_MODAL_ACTIONS_CANCEL: 'Cancelar',
  SHIPPING_WEIGHTS_MODAL_TITLE: 'Seleciona os pesos do produto {product}',
  SHIPPING_INVALID_DISCOUNTS_TAG: 'Ajustar descontos',
  SHIPPING_MAX_DISCOUNTS_TAG: 'Desconto máximo ultrapassado',
  SHIPPING_MODIFIED_WEIGHTS_TAG: 'Pesos modificados',
  SHIPPING_TOOLTIP_WEIGHT_ERROR: 'O preço não deve ser inferior a escalões de kg inferiores',
  SHIPPING_TOOLTIP_ZONE_ERROR:
    'O preço de {weight} kg do escalão {zone1} deve ser superior ao preço de {weight} kg do escalão {zone2}',
  SHIPPING_TOOLTIP_ZONE_ERROR_ALLOW_EQUAL:
    'O preço de {weight} kg do escalão {zone1} deve ser superior ou igual ao preço de {weight} kg do escalão {zone2}',
  SHIPPING_TOOLTIP_PRODUCT_ERROR:
    'O preço de {weight} do escalão {zone} do produto {product1} deve ser {percentage}% superior ao preço de {weight} do escalão {zone} do produto {product2}.',
  SHIPPING_TOOLTIP_PRODUCT_ERROR_NO_PERCENTAGE:
    'O preço de {weight} do escalão {zone} do produto {product1} deve ser superior ao preço de {weight} do escalão {zone} do produto {product2}.',

  // step 2
  ADDITIONAL_SERV_TITLE: 'Configura os preços dos serviços adicionais',
  ADDITIONAL_SERV_NONE_TITLE: 'Serviços adicionais',
  ADDITIONAL_SERV_DESCRIPTION:
    'Alguns serviços não permitem alterar o seu preço. Os preços podem ser fixos ou uma percentagem do total.',
  ADDITIONAL_SERV_NONE_DESCRIPTION:
    'Este modelo tarifário não tem serviços adicionais negociáveis.',
  ADDITIONAL_SERV_EDITION_DESCRIPTION: 'Configura o preço do serviço',
  ADDITIONAL_SERV_FIELD_BASE_PRICE: 'Preço base',
  ADDITIONAL_SERV_FIELD_PRICE: 'Montante ',
  ADDITIONAL_SERV_FIELD_PERCENTAGE: 'Percentagem ',
  ADDITIONAL_SERV_FIELD_SELECT: 'Código',
  ADDITIONAL_SERV_FIELD_SELECTOR: 'Selecionar um código',
  ADDITIONAL_SERV_FIELD_MIN: 'Mínimo',
  ADDITIONAL_SERV_FIELD_MAX: 'Máximo',
  ADDITIONAL_SERV_FIELD_MIN_QUANTITY: 'Quantidade mínima',
  ADDITIONAL_SERV_FIELD_MAX_QUANTITY: 'Quantidade máxima',
  ADDITIONAL_SERV_FIELD_EXPIRE_MONTHS: 'Meses de vigência',
  ADDITIONAL_SERV_SUFFIX_EXPIRE_MONTHS: 'meses',
  ADDITIONAL_SERV_EXPANSION_BUTTON_CANCEL: 'Cancelar',
  ADDITIONAL_SERV_EXPANSION_BUTTON_SAVE: 'Guardar',
  ADDITIONAL_SERV_VIEW_MORE: 'Ver outros serviços adicionais',
  ADDITIONAL_SERV_MODAL_TITLE: 'Serviços Adicionais',
  ADDITIONAL_SERV_MODAL_ACTIONS_CLOSE: 'Fechar',
  ADDITIONAL_SERV_RULE_MANDATORY: 'Valor obrigatório',
  ADDITIONAL_SERV_RULE_STD_MIN_VALUE: 'O preço base mínimo é {value}{suffix}',
  ADDITIONAL_SERV_RULE_STD_MAX_VALUE: 'O preço base máximo é {value}{suffix}',
  ADDITIONAL_SERV_RULE_MIN_VALUE: 'A quantidade mínima não pode ser superior a {value}€',
  ADDITIONAL_SERV_RULE_MAX_VALUE: 'A quantidade máxima não pode ser inferior a {value}€',

  // Additional Services
  TEST: 'Teste tipo lista/com select',
  SATURDAY_DELIVERY: 'Entrega ao Sábado (apenas para serviço 10:00h, 14:00h)',
  FINAL_MANAGE:
    'Gestão Final (serviços que requeiram alguma gestão na recolha ou na entrega)',
  ANT_BASE: 'Serviço Antecipação valor Base',
  ANT_COMMISSION: 'Serviço de Antecipação',
  REFUND: 'Serviço de Reembolso',
  REFUND_2024: 'Comissão Serviço de Reembolsos (os envios com reembolso não entregues não estão sujeitos a esta comissão)',
  CTT_CARD: 'Cartão CTT PLUS (1 ano)',
  FUEL: 'Bonificação Taxa Combustível',
  GROUPED_RETURN: 'Devolução agrupada guia física do cliente',
  OUTSKIRTS_KM: 'Quilómetros emissão Serviço 10:00h',
  DEST_PRINTING: 'Impressão no Destino até 5 folhas',
  ADIT_PRINTING: 'Impressão Adicional no Destino',
  DNI_VALIDATION: 'Validação do NIF do destinatário',
  OTP_TEXT: 'Serviço de entrega com OTP (One Time Password): Garante através de um código PIN a entrega ao destinatário final.',
  GRANDES_SUPERFICIES: 'Entrega em Grande Superfície (Serviço Especial para entregas em Grandes Superfícies e Centros Logísticos). Este serviço será faturado por entrega, dia e por cada morada diferente.',
  SCAN_DELIVERY_NOTE: 'Guia Cliente Digitalizada',
  DGR: 'DGR - MMPP (Gelo Seco Baleares/Canárias)',
  REEX_CAN_INTER: 'Reexpedição Canárias Inter Ilhas',
  REEX_CAN_KG: 'Reexpedição Canárias Inter Ilhas Kg Ad.',
  REEX_CAN_INTER_48: 'Reexpedição Canárias Inter Ilhas 48M 1 kg',
  REEX_CAN_INTER_48_MIN_50: 'Reexpedição Canárias Inter Ilhas Kg Ad. < 50 kg 48M',
  REEX_CAN_INTER_48_MAX_50: 'Reexpedição Canárias Inter Ilhas Kg Ad. > 50 kg 48M',
  PORTER: 'Ajudante / Moço (fração mín. 1 hora)',
  EXC_WEIGHT_40: 'Suplemento excesso peso por volume (desde 40 kg a 70 kg)',
  EXC_WEIGHT_70: 'Suplemento excesso peso por volume (desde 70 kg a 300 kg)',
  EXP_MEASURES_240: 'Suplemento excesso soma de medidas desde 240 cm até 300 cm',
  EXP_MEASURES_150: 'Suplemento excesso medida máxima desde 150 cm a 200 cm.',
  EXP_MEASURES_200: 'Suplemento excesso medida máxima desde 200 até 240 cm.',
  INTERCITY_KG: 'Suplemento Intercity Kg Adicional',
  FOURTH_ATTEMPT: 'Quarta tentativa de entrega e seguintes',
  ECOMMERCE_HIGH_VALUE: 'Suplemento Canárias Ecommerce Alto Valor',
  REC_FAILED: 'Recolha falhada',
  REC_FAILED_PT: 'Recolha falhada PT (Portugal)',
  WAIT_TIME: 'Tempo de Espera (por minuto)',
  DIR_FURGO_500: 'Morada furgoneta 500 kg',
  KM_FURGO_500: 'Quilómetro furgoneta 500 kg',
  DIR_FURGO_1500: 'Morada furgoneta 1500 kg',
  KM_FURGO_1500: 'Quilómetro furgoneta 1500 kg',
  SM_FURGO_500: 'Serviço Mínimo furgoneta 500 kg',
  SM_FURGO_1500: 'Serviço Mínimo furgoneta 1500 kg',
  SEG_TX_VOL: 'Incremento de indemnização legal por perda ou roubo: Limite até 2.000€/envio (lei 15/09 CTTM. Art. 63). (Excluídas roturas, avarias que serão abonadas de acordo com o CMR)',
  POD: 'Prova de entrega',
  RWA: 'Suplemento RWA (em caso de morada incorreta)',
  REMOTE_AREAS_A: 'Áreas Remotas (Zonas A)',
  REMOTE_AREAS: 'Áreas Remotas (consultar em www.cttexpress.com)',
  REMOTE_AREAS_BC: 'Áreas Remotas (Zonas B-C)',
  REMOTE_AREAS_KG: 'Áreas Remotas kg',
  REMOTE_AREAS_KG_BC: 'Áreas Remotas kg (Zonas B-C)',
  SPC_HAND_EXC_DIM: 'SPECIAL HANDLING Exceed Dimensions',
  SUPL_EMBALAJE: 'Suplemento manipulação - Embalagem',
  SUPL_DIMENSION: 'Suplemento manipulação - Dimensão',
  SUPL_PESO: 'Suplemento manipulação - Peso (peso real superior a 31 kg)',
  DRY_ICE: 'Gelo Seco',
  DANGER_GOODS_ADG: 'Mercadorias Perigosas acessíveis (ADG)',
  DANGER_GOODS_IDG: 'Mercadorias Perigosas acessíveis (IDG)',
  PRIORITY: 'Envio Prioritário (sticker visível com prioridade)',
  SHIPMENT_9_MIN_70: 'Entrega antes das 9:00 < 70 Kgs.',
  SHIPMENT_9_MAX_70: 'Entrega antes das 9:00 > 70 Kgs.',
  SHIPMENT_10_MIN_70: 'Entrega antes das 10:00 < 70 Kgs.',
  SHIPMENT_10_MAX_70: 'Entrega antes das 10:00 > 70 Kgs.',
  SHIPMENT_12_MIN_70: 'Entrega antes das 12:00 < 70 Kgs.',
  SHIPMENT_12_MAX_70: 'Entrega antes das 12:00 > 70 Kgs.',
  EXPORT_OUT_UE: 'Taxa Tramitação exportação fora da UE (DUA)',
  BAT_LITIO: 'Baterias de lítio',
  SUST_BIO: 'Substâncias biológicas (Categoria B)',
  SATURDAY_FR: 'Entrega ao Sábado França',
  CORSICA: 'Serviço Córsega',
  DEV_SHIPMENTS: 'Devolução de envios não entregues',
  ENTR_INDV: 'Entregas a domicílios particulares',
  SEG_PORTES: 'Seguro Valor Portes',
  SEG_DECLARADO: 'Incremento de indemnização legal por perda ou roubo: Limite até 2.000€/envio (lei 15/09 CTTM. Art. 63). (Excluídas roturas, avarias que serão abonadas de acordo com o art 57 Lei 15/09 CTTM)',
  DUA_CAN_A_ALTO: 'DUA CTT Canárias Aéreo Alto valor',
  DUA_CAN_A_BAJO: 'DUA CTT Canárias Aéreo Baixo valor',
  DUA_CAN_MAR: 'DUA CTT Canárias Marítimo',
  DUA_MEL_ALTO_EX_PEN: 'DUA Melilla Alto valor Export Península',
  DUA_MEL_ALTO_IM_PEN: 'DUA Melilla Alto valor Export Melilla, Import Península',
  DUA_MELILLA_BAJO: 'DUA Melilla baixo valor',
  DUA_CEU: 'DUA Ceuta',
  DUA_GIB: 'DUA Gibraltar',
  DUA_AND: 'DUA Andorra',
  RECOGIDA: 'RECOLHA SUPLEMENTO EVITA FALHA SGC',
  INTERCITY: 'INTERCITY SUPLEMENTO EVITA FALHA SGC',
  REEXPEDICION: 'REEXPEDIÇÃO EVITA FALHA SGC',
  REC_DENTRO_UE: 'Recolhas dentro da UE',
  REC_FUERA_UE: 'Recolhas Fora da UE',
  SMS: 'Notificação SMS mudança de estado do envio',
  SMS_PT: 'SMS (Notificações)',
  GARANTIAS: 'GARANTIAS DE SERVIÇO EVITA FALHA SCG',
  VOL_CONVERSION: 'Conversão Volumétrica',
  VOL_CONVERSION_167A: 'Conversão a 167a',
  VOL_CONVERSION_167B: 'Conversão a 167b',
  SMS_SCG: 'SMS (SCG)',
  INTERCITY_SUP: 'Suplemento Intercity até 10kg',
  INTERCITY_ADIC: 'Suplemento Intercity Kg Adicional',
  SUPL_EXC_BULTO_KILO_ADIC:
    'Suplemento excesso peso por volume por kilo adicional (a partir de 300 kg)',
  SUPL_EXC_MEDIDAS_300: 'Suplemento excesso soma de medidas por cada 10 cm (a partir de 300 cm)',
  SUPL_EXC_MEDIDAS_240: 'Suplemento excesso medida máxima por cada 10 cm (a partir de 240 cm)',
  SUPL_IRREGULARES: 'Suplemento por volume para envios irregulares',
  SUPL_EXP_MULTIBULTO: 'Suplemento por expedição multivolumo (a partir do sexto volume)',
  GARANTIA_SGC: 'GARANTIAS DE SERVIÇO (SCG)',
  ENVIO_IMP_ADUANA_CEUTA: 'ENVIO - IMPOSTOS ALFÂNDEGA IPSI CEUTA, NÃO SUJEITO-LIVA ART. 78',
  ENVIO_IVA_IMP_MELILLA: 'ENVIO - IVA IMPORTAÇÃO ORIGEM MELILLA, NÃO SUJEITO-LIVA ART. 78 (TR109)',
  ENVIO_IMP_EXP_ENT_ISLAS: 'ENVIO - IMPOSTOS EXPORTAÇÃO ENTRADA ILHAS, NÃO SUJEITO-LIVA ART. 78',
  ENVIO_IVA_IMP_ENT_PEN: 'ENVIO - IVA IMPORTAÇÃO ENTRADA PENÍNSULA, NÃO SUJEITO-LIVA ART. 78',
  ENVIO_IMP_ADUANERO_CEUTA_MELILLA:
    'ENVIO - IMPOSTOS ALFANDEGÁRIOS CEUTA / MELILLA, NÃO SUJEITO-LIVA ART. 78',
  ENVIO_TRANS_ESP_AND: 'ENVIO - TRANSITÁRIO ESPANHOL/ANDORRANO',
  ENVIO_IVA_IMP_INT: 'ENVIO - IVA IMPORTAÇÃO INTERNACIONAL',
  ENTREGA_GRAN_SUPERFICIE: 'Entrega em Grande Superfície',
  ENTREGA_GRAN_SUPERFICIE__PDF_ONLY:
    '(Serviço Especial para entregas em Grandes Superfícies e Centros Logísticos). Este serviço será faturado por entrega, dia e por cada morada diferente',
  EXCESO_DIMENSIONES: 'Excesso de dimensões',
  NO_TRANSPORTABLE: 'Não transportável',
  NO_APILABLE: 'Não empilhável',
  EMBALAJE: 'Embalagem (AHS)',
  PESO: 'Peso (AHS)',
  INACTIVE: 'INATIVO',
  NOT_INCLUDED: 'Não incluído',
  NOT_INCLUDED_PT: 'Não incluído',
  EDP: 'Uso de Pontos Ctt Express:\n- Disponíveis mais de 17.000 pontos de serviço em toda a península ibérica, Ilhas Baleares, Açores e Madeira.\n- Recorde que para poder utilizar os Pontos Ctt Express os envios devem cumprir as seguintes características:\n  - Envio de 1 só volume.\n  - Peso máximo igual a 20 Kg.\n  - Soma de medidas > 160 cm (60 x 40 x 60).\n  - Sem serviço de retorno.\n  - Sem serviço de reembolso.\n  - Sem portes devidos.\n  - Sem serviço de gestão no destino.\n  - Sem serviço de digitalização de guia do cliente.\n  - Sem serviço de verificação de NIF do destinatário.\n\nServiço de entrega direta em ponto. Os utilizadores podem levantar os seus envios nos pontos de serviço. Desconto aplicável a cada envio para entrega direta em ponto (EDP).',
  ENTREGA_DIRECTA_PUNTO: 'Bonificação Entrega Direta em Ponto',
  RECOGIDA_DIRECTA_PUNTO: 'Bonificação Recolha Direta em Ponto',
  ENTREGA_PONTO_CTT: 'Desconto Ponto de Entrega Collectt',
  JANELA_RECOLHA_8_10: 'Janela de recolha das 8 às 10',
  JANELA_RECOLHA_10_13: 'Janela de recolha das 10 às 13',
  JANELA_RECOLHA_13_16: 'Janela de recolha das 13 às 16',
  JANELA_RECOLHA_16_19: 'Janela de recolha das 16 às 19',
  JANELA_RECOLHA_19_22: 'Janela de recolha das 19 às 22',
  ALTERACAO_MORADA_RECOLHA: 'Alteração de morada de recolha',
  ALTERACAO_DATA_RECOLHA: 'Alteração de data de recolha',
  ALTERACAO_JANELA_RECOLHA_8_10: 'Alteração de janela de recolha das 8 às 10',
  ALTERACAO_JANELA_RECOLHA_10_13: 'Alteração de janela de recolha das 10 às 13',
  ALTERACAO_JANELA_RECOLHA_13_16: 'Alteração de janela de recolha das 13 às 16',
  ALTERACAO_JANELA_RECOLHA_16_19: 'Alteração de janela de recolha das 16 às 19',
  ALTERACAO_JANELA_RECOLHA_19_22: 'Alteração de janela de recolha das 19 às 22',
  ALTERACAO_JANELA_ENTREGA_NOITE: 'Alteração Janela Entrega Noite',
  ALTERACAO_DATA_DE_ENTREGA: 'Alteração Data de Entrega',
  ALTERACAO_DADOS_DESTINATARIO: 'Alteração Dados de Destinatario',
  ALTERACAO_DADOS_REMETENTE: 'Alteração Dados de Remetente',
  ALTERACAO_PRAZO_LEVANTAMENTO: 'Alteração Prazo Levantamento',
  ALTERACAO_MORADA_MORADA_MESMA_REGIAO: 'Alteração Morada-Morada (mesma Região)',
  ALTERACAO_MORADA_PONTO_MESMA_REGIAO: 'Alteração Morada-Ponto (mesma Região)',
  ALTERACAO_PONTO_MORADA_MESMA_REGIAO: 'Alteração Ponto-Morada (mesma Região)',
  ALTERACAO_PONTO_PONTO_MESMA_REGIAO: 'Alteração Ponto-Ponto (mesma Região)',
  ALTERACAO_MORADA_MORADA_OUTRA_REGIAO: 'Alteração Morada-Morada (outra Região)',
  ALTERACAO_MORADA_PONTO_OUTRA_REGIAO: 'Alteração Morada-Ponto (outra Região)',
  ALTERACAO_PONTO_MORADA_OUTRA_REGIAO: 'Alteração Ponto-Morada (outra Região)',
  ALTERACAO_PONTO_PONTO_OUTRA_REGIAO: 'Alteração Ponto-Ponto (outra Região)',
  TAXA_COMBUSTIVEL: 'Desconto em P.P. na taxa de energia cep.',
  '1_TENTATIVA_AVISAR_A_LOJA_CTT': '1ª Tentativa Avisar a Loja CTT',
  '1_TENTATIVA_DEVOLVER': '1ª Tentativa Devolver',
  TAXA_CARGA_DISFORME: 'Taxa disforme carga (% do valor dos portes).',
  TAXA_RECOLHA_NAO_EFETUADA: 'Taxa Recolha não Efectuada',
  TAXA_DISFORME: 'Taxa Disforme',
  TAXA_DISFORME_DEVOLUCAO: 'Taxa de Disforme - Devolução',
  TAXA_DESPACHO_UNICO_ADUANEIRO: 'Taxa Despacho Único Aduaneiro (DUA)',
  TAXA_CARGA_VOLUME: 'Taxa de Volume não cintável',
  TAXA_CARGA_MD3: 'Taxa MD3',
  TAXA_CARGA_ENTREGA_GRANDES_SUPERFICIES: 'Taxa Grandes Superfícies',
  'TAXA_REMESSA_9+': 'Taxa Remessa 9+ (por Objeto Extra)',
  MANHA: 'Janela Entrega Manhã',
  TARDE: 'Janela Entrega Tarde',
  NOITE: 'Janela Entrega Noite',
  SABADO: 'Janela Entrega Sábado',
  DOMINGO: 'Janela Entrega Domingo',
  SEGURO_EXTRA_ATE_1000: 'Proteção Extra - Até 1.000€',
  SEGURO_EXTRA_ATE_2500: 'Proteção Extra - Até 2.500€',
  SEGURO_EXTRA_ATE_5000: 'Proteção Extra - Até 5.000€',
  SEGURO_EXTRA_ATE_7500: 'Proteção Extra - Até 7.500€',
  SEGURO_EXTRA_ATE_10000: 'Proteção Extra - Até 10.000€',
  SEGURO_EXTRA_ATE_12500: 'Proteção Extra - Até 12.500€',
  SABADOB2B: 'Entregas ao Sábado',
  FRAGIL: 'Frágil',
  BACK: 'Back',
  DDA: 'DDA',
  COBRANÇA: 'Cobrança',
  COBRANCA_CARGA: 'Cobrança (Carga)',
  DDA_CARGA: 'DDA (Carga)',
  '2_TENTATIVA_AVISAR_A_LOJA_CTT': '2 Tentativas + Avisar à Loja CTT',
  '2_TENTATIVA_DEVOLVER': '2 Tentativas + Devolver',
  TENTATIVA_DE_ENTREGA_ADICIONAL: 'Tentativa de entrega adicional',
  ENTREGA_CONJUNTA: 'Entrega conjunta',
  CONTACTO_TELEFONICO: 'Contacto telefónico',
  ALTERACAO_JANELA_ENTREGA_MANHA: 'Alteração de janela de entrega de manhã',
  ALTERACAO_JANELA_ENTREGA_TARDE: 'Alteração de janela de entrega à tarde',
  TXENRGDISC: 'Desconto em P.P. na Taxa de Energia',
  TXRECNEFECT: 'Taxa Recolha não Efectuada',
  TXDISFORME: 'Taxa de Disforme – Transporte',
  TXDISFORMEDEV: 'Taxa de Disforme – Devolução',
  TXDUA: 'Taxa Despacho Único Aduaneiro (DUA)',
  "TXREMESSA9+": 'Taxa Remessa 9+ (por Objeto Extra)',
  PONTOCTT: 'Entrega Ponto CTT (Desconto)',
  '1TENTCC': '1 Tentativa + Avisar à Loja CTT',
  '1TENTDEV': '1 Tentativa + Devolver',
  '2TENTCTT': '2 Tentativa + Avisar à Loja CTT',
  ADTENT: 'Tentativa de Entrega Adicional',
  CONJUNTA: 'Entrega Conjunta',
  CONTACTO: 'Contacto Telefónico',
  ALTMANHA: 'Alteração Janela Entrega Manhã',
  ALTTARDE: 'Alteração Janela Entrega Tarde',
  ALTNOITE: 'Alteração Janela Entrega Noite',
  ALTDATA: 'Alteração Data de Entrega',
  ALTDESTINO: 'Alteração Dados Destinatário',
  ALTORIGEM: 'Alteração Dados Remetente',
  ALTPRAZO: 'Alteração Prazo Levantamento',
  ALTM2M_MMR: 'Alteração Morada-Morada (mesma Região)',
  ALTM2P_MMR: 'Alteração Morada-Ponto (mesma Região)',
  ALTP2M_MMR: 'Alteração Ponto-Morada (mesma Região)',
  ALTP2P_MMR: 'Alteração Ponto-Ponto (mesma Região)',
  ALTM2M_OTR: 'Alteração Morada-Morada (outra Região)',
  ALTM2P_OTR: 'Alteração Morada-Ponto (outra Região)',
  ALTP2M_OTR: 'Alteração Ponto-Morada (outra Região)',
  ALTP2P_OTR: 'Alteração Ponto-Ponto (outra Região)',
  REC1922: 'Janela Recolha 19-22',
  ALT0810: 'Alteração Janela Recolha 08-10',
  ALT1013: 'Alteração Janela Recolha 10-13',
  ALT1316: 'Alteração Janela Recolha 13-16',
  ALT1619: 'Alteração Janela Recolha 16-19',
  ALT1922: 'Alteração Janela Recolha 19-22',
  ALTMOR_MR: 'Alteração Morada Mesma Região',
  ALTMOR_OR: 'Alteração Morada Outra Região',

  STEPPER_DISTRIBUTION_B2B: 'Distribuição B2B (%)',
  STEPPER_DISTRIBUTION_B2C: 'Distribuição B2C (%)',
  STEPPER_DISTRIBUTION_ERROR: 'A soma deve ser exatamente 100%',

  // Step 3
  STEPPER_STEP3_TITLE: 'Forma de pagamento selecionada',
  STEPPER_STEP3_APPROVED_TITLE: 'Formas de pagamento aprovadas',
  STEPPER_STEP3_WITHOUT_PAYMENT_DAY: 'Sem dia de pagamento',
  STEPPER_STEP3_UNAPPROVED_TITLE: 'Formas de pagamento que necessitam de aprovação',
  STEPPER_STEP3_VIEW_MORE: 'Ver mais formas de pagamento',
  STEPPER_STEP3_VIEW_LESS: 'Ver menos formas de pagamento',
  PAYMENT_METHOD_RECEIPT: 'Débito direto imediato',
  PAYMENT_METHOD_RECEIPT30: 'Débito direto a 30 dias',
  PAYMENT_METHOD_RECEIPT60: 'Débito direto a 60 dias',
  STEPPER_STEP3_PAYMENT_DAY_TITLE: 'Dia de pagamento',
  STEPPER_STEP3_PAYMENT_DAY_LABEL: 'Dia de pagamento selecionado',
  PAYMENT_METHOD_TRANS30: 'Transferência a 30 dias',
  PAYMENT_METHOD_TRANS60: 'Transferência a 60 dias',
  PAYMENT_METHOD_CHECK30: 'Cheque a 30 dias',
  PAYMENT_METHOD_CHECK60: 'Cheque a 60 dias',
  PAYMENT_METHOD_PAGARE30: 'Nota promissória 30 dias',
  PAYMENT_METHOD_PAGARE60: 'Nota promissória 60 dias',
  PAYMENT_METHOD_CONFIRM30: 'Confirming a 30 dias',
  PAYMENT_METHOD_CONFIRM60: 'Confirming a 60 dias',
  PAYMENT_METHOD_TRANS: 'Transferência imediata',
  PAYMENT_METHOD_DIRECT: 'Direct Lending',
  STEPPER_STEP3_BANK_GUARANTEE_TITLE: 'Dados da garantia',
  GUARANTEE_AMOUNT: 'Montante da garantia',
  GUARANTEE_TYPE_LABEL: 'Tipo de garantia',
  GUARANTEE_TYPE_CASH: 'Depósito em numerário',
  GUARANTEE_TYPE_BANK: 'Garantia bancária',
  GUARANTEE_DURATION_LABEL: 'Duração da garantia',
  GUARANTEE_DURATION_UNDEFINED: 'Indefinido',
  GUARANTEE_DURATION_18_MONTHS: '18 meses',
  GUARANTEE_DURATION_30_MONTHS: '30 meses',
  GUARANTEE_DURATION_42_MONTHS: '42 meses',
  STEPPER_STEP3_DAYS_RULE_MANDATORY: 'Deve indicar o número de dias',
  STEPPER_STEP3_DAYS_RULE_MIN: 'O dia de pagamento deve ser superior a 0',
  STEPPER_STEP3_DAYS_RULE_MAX: 'O dia de pagamento não pode ser superior a 30',
  STEPPER_STEP3_BANK_RULE_MANDATORY: 'Deve indicar um montante para a garantia',
  PAYMENT_METHOD_DEBITO_DIRETO: 'Débito Direto',
  PAYMENT_METHOD_TRANSFERENCIA_BANCARIA_30: 'Transferência Bancária 30 Dias',
  PAYMENT_METHOD_TRANSFERENCIA_BANCARIA_60: 'Transferência Bancária 60 Dias',
  PAYMENT_METHOD_REFERENCIA_MULTIBANCO_30: 'Referência Multibanco 30 Dias',
  PAYMENT_METHOD_REFERENCIA_MULTIBANCO_60: 'Referência Multibanco 60 Dias',
  PAYMENT_METHOD_PAYSHOP_30: 'Payshop 30 Dias',
  PAYMENT_METHOD_PAYSHOP_60: 'Payshop 60 Dias',
  METHOD_DEBITO_DIRETO: 'Débito Direto',
  METHOD_TRANSFERENCIA_BANCARIA_30: 'Transferência Bancária 30 Dias',
  METHOD_TRANSFERENCIA_BANCARIA_60: 'Transferência Bancária 60 Dias',
  METHOD_REFERENCIA_MULTIBANCO_30: 'Referência Multibanco 30 Dias',
  METHOD_REFERENCIA_MULTIBANCO_60: 'Referência Multibanco 60 Dias',
  METHOD_PAYSHOP_30: 'Payshop 30 Dias',
  METHOD_PAYSHOP_60: 'Payshop 60 Dias',

  //Unlock discounts
  UNLOCK_DISCOUNTS_MODAL_TITLE:
    'Pretende desbloquear os descontos ultrapassando o desconto máximo recomendado?',
  UNLOCK_DISCOUNTS_MODAL_DESCRIPTION1:
    'Ao desbloquear os descontos, poderá ultrapassar o limite máximo de desconto estabelecido.',
  UNLOCK_DISCOUNTS_MODAL_DESCRIPTION2:
    'A oferta passará para o estado "Não aprovada" e deverá ser revista pelo aprovador',
  UNLOCK_DISCOUNTS_MODAL_CANCEL: 'Cancelar',

  // Confirmação finalização de oferta
  FINALIZE_OFFER_MODAL_TITLE: 'Tem a certeza de que pretende finalizar a oferta?',
  FINALIZE_OFFER_MODAL_DESCRIPTION: 'Por favor, antes de finalizar, verifique que os descontos dos serviços adicionais oferecidos não foram alterados.',
  FINALIZE_OFFER_MODAL_CANCEL: 'Cancelar',
  FINALIZE_OFFER_MODAL_CONTINUE: 'Continuar',
  LOCK_DISCOUNTS_MODAL_TITLE:
    'Pretende bloquear os descontos e recuperar o desconto máximo recomendado?',
  LOCK_DISCOUNTS_MODAL_DESCRIPTION1:
    'Ao bloquear os descontos, recuperará o limite máximo de desconto estabelecido.',
  LOCK_DISCOUNTS_MODAL_DESCRIPTION2:
    'Perderá as modificações que tenham ultrapassado o desconto máximo permitido.',
  LOCK_DISCOUNTS_MODAL_CANCEL: 'Cancelar',

  // Step 4
  STEPPER_STEP4_TITLE: 'Introduza a informação de detalhe dos volumes',
  STEPPER_STEP4_DESC1: 'Para as ofertas do tipo {offerType} ',
  STEPPER_STEP4_DESC2: 'é necessário incluir informação adicional sobre os volumes',
  STEPPER_STEP4_SUBTITLE: 'Informação dos volumes',
  STEPPER_STEP4_TEXTFIELD1: 'N.º de volumes por expedição',
  STEPPER_STEP4_TEXTFIELD2: 'Tipo de mercadoria',
  STEPPER_STEP4_SUBTITLE2: 'Detalhes',
  STEPPER_STEP4_SUBTITLE3: 'Observações',
  STEPPER_STEP4_TEXTFIELD3: 'N.º de envios com reembolso (mês)',
  STEPPER_STEP4_TEXTFIELD4: 'Valor médio do reembolso (€)',
  STEPPER_STEP4_SUBTITLE4: 'Dias de recolha semanais',
  STEPPER_STEP4_CHIP_MONDAY: 'Segunda-feira',
  STEPPER_STEP4_CHIP_TUESDAY: 'Terça-feira',
  STEPPER_STEP4_CHIP_WEDNESDAY: 'Quarta-feira',
  STEPPER_STEP4_CHIP_THURSDAY: 'Quinta-feira',
  STEPPER_STEP4_CHIP_FRIDAY: 'Sexta-feira',
  STEPPER_STEP4_CHIP_SATURDAY: 'Sábado',
  STEPPER_STEP4_CHIP_SUNDAY: 'Domingo',
  STEPPER_STEP4_CHIP_MONDAY_TO_FRIDAY: 'De segunda a sexta-feira',
  STEPPER_STEP4_HEADER_TYPE: 'Tipo de volume',
  STEPPER_STEP4_HEADER_WEIGHT: 'Peso (kg)',
  STEPPER_STEP4_HEADER_LONG: 'Comprimento (cm)',
  STEPPER_STEP4_HEADER_WIDTH: 'Largura (cm)',
  STEPPER_STEP4_HEADER_HEIGHT: 'Altura (cm)',
  STEPPER_STEP4_HEADER_PERCENTAGE: '% do total de volumes',
  STEPPER_STEP4_TABLE_DIALOG_TITLE: 'Dados do volume',
  STEPPER_STEP4_TABLE_DIALOG_BUTTON_CLOSE: 'Cancelar',
  STEPPER_STEP4_TABLE_DIALOG_BUTTON_SAVE: 'Guardar',
  STEPPER_STEP4_TABLE_TOTAL: 'Total',
  STEPPER_STEP4_ERROR_MESSAGE: 'Deve preencher este campo',
  STEPPER_STEP4_DAYS_OF_WEEK_REQUIRED: 'Deve selecionar pelo menos um dia da semana',
  STEPPER_STEP4_NUMBER_ERROR_MESSAGE: 'Este campo deve conter um número maior que 0',
  STEPPER_STEP4_NUMBER_NUMBEROFREFUNDS_0:
    'Este campo deve ser 0, pois o valor médio do reembolso é 0',
  STEPPER_STEP4_REFUNDS_VALUE_0:
    'Este campo deve ser 0, pois o número de envios com reembolso é 0',
  STEPPER_STEP4_COMMITED_DELIVERIES_ERROR:
    'Este campo não deve superar o número de envios comprometidos',
  STEPPER_STEP4_EXCEEDED_ERROR_MESSAGE: 'A percentagem total dos volumes deve somar 100%',
  STEPPER_STEP4_OBSERVATION_ERROR_MESSAGE: 'As observações devem ter menos de 350 caracteres',
  STEPPER_STEP4_OBSERVATION_LABEL: 'Comentário/observação (máx. 350 caracteres)',
  STEPPER_STEP4_MODIFY_ITEM_MODAL_SAVE: 'Guardar',
  STEPPER_STEP4_MODIFY_ITEM_MODAL_CANCEL: 'Cancelar',
  STEPPER_STEP4_DELETE_TABLE_ITEM: 'Confirma a eliminação deste volume?',
  STEPPER_STEP4_DELETE_MODAL_TITLE: 'Eliminar volume',
  STEPPER_STEP4_DELETE_BUTTON: 'Eliminar volume',
  CLOTHING: 'Têxtil',
  COSMETICS: 'Cosmética',
  STATIONERY: 'Papelaria',
  PERFUMERY: 'Perfumaria',
  OPTICS: 'Ótica',
  REPLACEMENTS: 'Peças de substituição',
  ANIMAL_FOOD: 'Alimentação animal',
  JEWELLERY: 'Joalharia',
  HERBALIST: 'Ervanária',
  BOOKS: 'Livros',
  FURNITURE: 'Mobiliário',
  DOCUMENTS: 'Documentação',
  TECHNOLOGY: 'Tecnologia',
  SHOES: 'Sapatos',
  WINES_AND_DRINKS: 'Vinho e bebidas',
  FRUITS: 'Fruta',
  APPLIANCES: 'Eletrodomésticos',
  WHEELS: 'Rodas',
  CAR_GLASS: 'Vidros',
  HARDWARE_STORE: 'Ferragens (Ferramentas manuais)',
  OTHERS: 'Outros (indicar observações)',

  // Step 5
  STEPPER_STEP5_TITLE: 'Configura a dispersão dos produtos da oferta',
  STEPPER_STEP5_EDITION_DESCRIPTION: 'Configura a dispersão do produto e das zonas',
  STEPPER_STEP5_TOTAL_MESSAGE: 'Total: {sum}',
  STEPPER_STEP5_FIELD_PRODUCT_DISPERSION: 'Dispersão do produto',
  STEPPER_STEP5_FIELD_ZONES: 'Para cada zona',
  STEPPER_STEP5_FIELD_ZONES_DESCRIPTION: '@.upper:STEPPER_STEP5_FIELD_ZONES',
  STEPPER_STEP5_FIELD_ZONES_CHIP_ERROR: 'A soma das zonas não pode ser {sum}',
  STEPPER_STEP5_ALERT_ERROR_BASIC:
    'A soma da dispersão dos produtos deve ser igual a 100 %',
  STEPPER_STEP5_ALERT_ERROR:
    'A soma da dispersão dos produtos supera em {difference} % o máximo. Não pode superar 100 %',
  STEPPER_STEP5_ALERT_ERROR_MINUS:
    'A soma da dispersão dos produtos é {difference} % inferior ao limite. Não pode ser inferior a 100 %',
  STEPPER_STEP5_DESCRIPTION:
    'Detalhar a dispersão (%) de cada produto e de cada zona dentro do produto.',

  STEPPER_SAVE_SUCCESS_ALERT_MESSAGE: 'A oferta foi guardada com sucesso.',
  STEPPER_SAVE_ERROR_ALERT_MESSAGE: 'Ocorreu um erro e não foi possível guardar a oferta.',
  STEPPER_SAVE_CRM_ERROR_ALERT_MESSAGE:
    'Ocorreu um erro de comunicação com o CRM e não foi possível guardar a oferta.',

  STEPPER_RESET_DIALOG_TITLE: 'Pretende continuar?',
  STEPPER_RESET_DIALOG_DESC:
    'Ao cancelar a oferta, todas as alterações serão perdidas e regressará ao passo inicial. Esta ação não pode ser desfeita.',
  STEPPER_RESET_DIALOG_BUTTON_CANCEL: 'Não',
  STEPPER_RESET_DIALOG_BUTTON_CONFIRM: 'Sim',
  STEPPER_RESET_SUCCESS_ALERT_MESSAGE: 'A oferta foi cancelada.',
  STEPPER_RESET_ERROR_ALERT_MESSAGE: 'Ocorreu um erro ao cancelar a oferta.',

  STEPPER_MANUAL_SIGN_DIALOG_TITLE: 'Pretende continuar?',
  STEPPER_MANUAL_SIGN_DIALOG_TEXT:
    'O contrato será marcado como assinado pelo cliente e, por isso, será registado nos CTT. Este passo é definitivo.',
  STEPPER_MANUAL_SIGN_DIALOG_BUTTON_CONFIRM: 'Assinar',
  STEPPER_MANUAL_SIGN_DIALOG_BUTTON_CANCEL: 'Cancelar',
  STEPPER_MANUAL_SIGN_SUCCESS_ALERT_MESSAGE: 'A oferta foi assinada manualmente',
  STEPPER_MANUAL_SIGN_ERROR_ALERT_MESSAGE:
    'Ocorreu um erro e não foi possível assinar manualmente a oferta',

  STEPPER_EDIT_VALIDATED_OFFER_DIALOG_TITLE: 'Pretende continuar?',
  STEPPER_EDIT_VALIDATED_OFFER_DIALOG_TEXT:
    'A oferta está aprovada; se a modificar voltará a estar pendente de aprovação.',
  STEPPER_EDIT_VALIDATED_OFFER_DIALOG_BUTTON_CONFIRM: 'Confirmar',
  STEPPER_EDIT_VALIDATED_OFFER_DIALOG_BUTTON_CANCEL: 'Cancelar',

  STEPPER_PHANTOM_OFFER_TITLE: 'Oferta do tipo F',
  STEPPER_PHANTOM_OFFER_TEXT_SIGN:
    'A oferta do tipo F foi finalizada. Em caso de assinar o contrato com o cliente, clique em Assinatura Manual.',
  STEPPER_PHANTOM_OFFER_TEXT_SIGNED: 'Oferta assinada com sucesso.',

  OFFER_REQUIRED_CLIENT_DATA_ERROR:
    'Faltam dados obrigatórios do cliente como: razão social, NIF, morada ou cidade',
  OFFER_REQUIRED_MAIN_CONTACT_NIF_ERROR:
    'É necessário incluir o NIF do contacto principal na oferta',
  OFFER_REQUIRED_BANK_DATA_DEBIT_ERROR: 'É necessário adicionar os dados bancários da conta',
  OFFER_REQUIRED_BANK_DATA_REFUND_ERROR:
    'É necessário adicionar os dados bancários para a gestão de reembolsos',

  //Contract
  PAGE2_COMMERCIAL: 'Su gestor comercial:',
  PAGE2_P1: 'Estimado/a cliente',
  PAGE2_P2:
    'Deseo agradecerte la confianza que has depositado en CTT Express como mejor opción para tus envíos de paquetería urgente.',
  PAGE2_P3:
    'A través de esta oferta de servicios de paquetería, queremos demostrarte que tenemos la mejor gama de servicios de paquetería urgente para el mercado Ibérico, incluyendo España y Portugal.',
  PAGE2_P4:
    'Esperando convertirnos muy pronto en un aliado para tu negocio, recibe un cordial saludo.',
  PAGE2_P5: 'Atentamente',
  PAGE2_COMMERCIAL_PT: 'Gestor comercial:',
  PAGE2_P1_PT: 'Estimado/a cliente',
  PAGE2_P2_PT:
    'Gostaria de agradecer a confiança que depositou nos CTT, escolhendo-nos como a melhor opção para os seus envios de encomendas expresso.',
  PAGE2_P3_PT:
    'Com esta oferta de serviços, pretendemos mostrar-lhe que dispomos da melhor oferta de soluções de encomendas expresso no mercado ibérico, incluindo tanto Portugal como Espanha.',
  PAGE2_P4_PT:
    'Esperamos em breve ser o parceiro estratégico para seu negócio.',
  PAGE2_P5_PT: 'Atentamente,',
  PAGE2_DIRECTOR_NAME: 'Jorge Bousquet Alfonso',
  PAGE2_DIRECTOR_NAME_PT: 'Francisco Simões Travassos',
  PAGE2_DIRECTOR_JOB: 'Director Comercial de CTT EXPRESS',
  PAGE2_DIRECTOR_JOB_PT: 'Diretor de Produto CTT EXPRESS',

  PAGE_SIGNATURE_TITLE: 'Acordo Comercial de Prestação de Serviços de Transporte (APS)',
  PAGE_SIGNATURE_TITLE_PT: 'Acordo de Prestação de Serviços de Transporte (APS)',
  SIGNATURE_SENT_DATE: 'Data de Envio',
  SIGNATURE_STATUS: 'Estado da assinatura',
  SIGNATURE_DOCUMENT_ID: 'ID Documento',
  SIGNATURE_SIGN_ID: 'ID Assinatura',
  SIGNATURE_STATE_BTN: 'Atualizar Estado',
  SIGNATURE_SENT: 'O contrato foi enviado para assinatura com sucesso',
  SIGNATURE_ERROR: 'Ocorreu um erro ao enviar o contrato',
  SIGNATURE_CANCEL_ERROR:
    'Erro ao cancelar o processo de assinatura. Por favor, tente novamente mais tarde',
  SIGNATURE_CANCEL_NOT_ALLOWED: 'O estado da oferta não permite cancelar o processo de assinatura',
  SIGNATURE_UPDATE_ERROR:
    'Erro ao atualizar o estado da assinatura. Por favor, tente novamente mais tarde',
  SIGN_CANCEL_BUTTON: 'Cancelar assinatura',
  CONTRACT_MODEL_NOT_VALID: 'O contrato associado ao modelo tarifário selecionado não é válido',
  IN_QUEUE: 'Na fila',
  EMAIL_PROCESSED: 'Email processado',
  EMAIL_DELIVERED: 'Email enviado',
  EMAIL_OPENED: 'Email aberto',
  EMAIL_BOUNCED: 'Email rejeitado',
  EMAIL_DEFERRED: 'Email rejeitado. Tentando novamente',
  REMINDER_EMAIL_PROCESSED: 'Email de lembrete processado',
  REMINDER_EMAIL_DELIVERED: 'Email de lembrete enviado',
  REMINDER_EMAIL_OPENED: 'Email de lembrete aberto',
  DOCUMENT_OPENED: 'Documento aberto',
  DOCUMENT_SIGNED: 'Documento assinado',
  DOCUMENT_COMPLETED: 'Contrato assinado',
  DOCUMENT_DECLINED: 'Documento recusado',
  DOCUMENT_EXPIRED: 'Documento expirado',
  DOCUMENT_CANCELED: 'Documento cancelado',
  DECLINED: 'Processo recusado',
  CANCELED: 'Processo cancelado',
  AUDIT_TRAIL_COMPLETED: 'Contrato assinado',
  EXPIRED: 'Processo expirado',
  ERROR: 'Erro',
  MANUALLY_SIGNED: 'Assinatura manual',

  //SHIPPING PRODUCTS
  PRODUCT_24H: 'CTT 24h - CTT e24h',
  PRODUCT_13h: 'CTT 14h',
  PRODUCT_10h: 'CTT 10h',
  PRODUCT_08h: 'CTT 08:30h',
  PRODUCT_48h: 'CTT 48h - CTT e48h',
  PRODUCT_OTHERDESTINATIONS: 'CTT Outros destinos',
  PRODUCT_CAN13H: 'Canarias 14:00h',
  PRODUCT_CAN24H: 'Canarias 24h',
  PRODUCT_CANECOMMERCE: 'CTT Canarias Aéreo 24h',
  PRODUCT_CANMARITIMO: 'CTT Canarias Marítimo',
  PRODUCT_BAL13H: 'Baleares 14:00h',
  PRODUCT_BAL24H: 'Baleares 24h - e24h',
  PRODUCT_BAL48H: 'Baleares 48h - e48h',
  PRODUCT_INTEXP: 'CTT Internacional Express',
  PRODUCT_INTSTD: 'CTT Internacional Economy',
  PRODUCT_ECOMM: 'CTT Internacional Ecommerce',
  PRODUCT_INTREG: 'Internacional Regional',
  PRODUCT_INTPRIOR: 'Internacional Priority',
  PRODUCT_ELIGHT: 'CTT Internacional Europa Light',
  PRODUCT_CIEL: 'CTT Internacional Europa Light',
  PRODUCT_CANEXPRESS: 'CTT Canarias Documentación',
  PRODUCT_BALEXPRESS: 'CTT Baleares Express',
  PRODUCT_BALECONOMY: 'CTT Baleares Economy',
  PRODUCT_C14E: 'CTT Premium Empresas 14h',
  PRODUCT_CCA24: 'CTT Canarias Aéreo 24h',
  PRODUCT_CCA48: 'CTT Canarias Aéreo 48h',
  PRODUCT_EUROPE: 'Europa',
  PRODUCT_WORLD: 'Resto do mundo',
  PRODUCT_e24h: 'Para Amanhã',
  PRODUCT_e48h: 'Em Dois Dias',
  PRODUCT_19H_19M: '19H',
  PRODUCT_TARIFF_STANDARD_E24H: 'e24h (Para Amanhã; Devoluçao Fácil)',
  PRODUCT_TARIFF_STANDARD_E48H: '48h (Em 2 Dias)',
  PRODUCT_TARIFF_STANDARD_10H: 'CTT 10h',
  PRODUCT_TARIFF_STANDARD_13H: 'CTT 14h',
  PRODUCT_TARIFF_STANDARD_19H_19M: '24h / 24hM ( 19h / 19M )',
  PRODUCT_TARIFF_STANDARD_48H: 'CTT 48h - CTT e48h',
  PRODUCT_TARIFF_STANDARD_PTE: 'Ilhas PT (Aéreo)',
  PRODUCT_TARIFF_STANDARD_PTE_ACORES: 'Ilhas PT (Aéreo) - Açores',
  PRODUCT_TARIFF_STANDARD_PTE_MADEIRA: 'Ilhas PT (Aéreo) - Madeira',
  PRODUCT_TARIFF_STANDARD_PTM: 'Ilhas PT (Marítimo)',
  PRODUCT_TARIFF_STANDARD_PTI: 'Interilhas PT',
  PRODUCT_TARIFF_STANDARD_BALEXPRESS: 'CTT 24h (Baleares)',
  PRODUCT_TARIFF_STANDARD_BALMARITIMO: 'CTT Marítimo (Baleares)',
  PRODUCT_TARIFF_STANDARD_CANEXPRESS: 'CTT 24h (Canárias)',
  PRODUCT_TARIFF_STANDARD_OTHERDESTINATIONS: 'Outros Destinos',
  PRODUCT_TARIFF_STANDARD_24H: 'CTT 24h - CTT e24h',
  PRODUCT_TARIFF_STANDARD_10H_PT: 'CTT 10h',
  PRODUCT_TARIFF_STANDARD_13H_PT: 'CTT 13h',
  PRODUCT_TARIFF_STANDARD_48H_PT: 'CTT 48h',
  PRODUCT_TARIFF_STANDARD_14H_PT: 'CTT 14h',
  PRODUCT_TARIFF_STANDARD_24H_PT: 'CTT 24h',
  PRODUCT_TARIFF_STANDARD_E24H_PT: 'CTT e24h / Easy Return',
  PRODUCT_TARIFF_STANDARD_E48H_PT: 'CTT e48h (Em 2 Dias)',
  PRODUCT_TARIFF_STANDARD_PTIEXPRESS: 'CTT 24h (Ilhas PT)',
  PRODUCT_TARIFF_STANDARD_PTIEXPRESS_RAA: 'CTT 24h (Ilhas PT) - Açores',
  PRODUCT_TARIFF_STANDARD_PTIEXPRESS_LPMA: 'CTT 24h (Ilhas PT) - Madeira',
  PRODUCT_TARIFF_STANDARD_PTIECONOMY: 'CTT Marítimo (Ilhas PT)',
  PRODUCT_TARIFF_STANDARD_BALECONOMY: 'CTT Marítimo (Baleares)',
  PRODUCT_TARIFF_STANDARD_CANECONOMY: 'CTT Marítimo (Canárias)',
  PRODUCT_TARIFF_STANDARD_OTHERDESTINATIONS_PT: 'Outros Destinos',
  PRODUCT_TARIFF_STANDARD_CCAR_PT: 'Carga',
  PRODUCT_OtrosDestinos: 'Outros Destinos',
  PRODUCT_CanariasAereo: 'Canarias (Aéreo)',
  PRODUCT_Interilhas_PT: 'Interilhas PT',
  PRODUCT_InterilhasPT: 'Interilhas PT',
  PRODUCT_BalearesAereo: 'Baleares (Aéreo)',
  PRODUCT_BalearesMaritimo: 'Baleares (Marítimo)',
  PRODUCT_IlhasPTE: 'Ilhas PT (Aéreo)',
  PRODUCT_IlhasPTM: 'Ilhas PT (Marítimo)',
  PRODUCT_JSON_CANEXPRESS: 'CTT Canarias Documentación',
  PRODUCT_TARIFF_CANARY_ECOMMERCE: 'CTT Canarias Aéreo',
  PRODUCT_TARIFF_STANDARD_CCA24: 'CTT Canarias Aéreo 24h',
  PRODUCT_TARIFF_STANDARD_CCA48: 'CTT Canarias Aéreo 48h',
  PRODUCT_TARIFF_CANARY_MARITIME: 'CTT Canarias Marítimo',
  PRODUCT_JSON_BALEXPRESS: 'CTT Baleares Express',
  PRODUCT_JSON_BALECONOMY: 'CTT Baleares Economy',
  PRODUCT_JSON_INTEXP: 'CTT Internacional Express',
  PRODUCT_JSON_INTSTD: 'CTT Internacional Economy',
  PRODUCT_TARIFF_STANDARD_CIEL: 'CTT Internacional Europa Light',

  //PDF
  PDF_GENERATING: 'A gerar o contrato',
  WEIGHT: 'Peso',
  ADD_KILO: 'Kg adic',
  ZONE_Prov: 'Provincial',
  ZONE_Reg: 'Regional',
  ZONE_Peninsular: 'Peninsular',
  ZONE_PeninsularPlus: 'Peninsular+',
  ZONE_ZONE1: 'Zona 1',
  ZONE_ZONE2: 'Zona 2',
  ZONE_ZONE3: 'Zona 3',
  ZONE_ZONE4: 'Zona 4',
  ZONE_ZONE5: 'Zona 5',
  ZONE_ZONE6: 'Zona 6',
  ZONE_ZONE7: 'Zona 7',
  ZONE_ZONE8: 'Zona 8',
  ZONE_ZONE9: 'Zona 9',
  ZONE_FRANCIA: 'França',
  ZONE_FR: 'França',
  ZONE_BALMAY: 'Maiorca',
  ZONE_BALMEN: 'Resto das Ilhas',
  ZONE_DE: 'Alemanha',
  ZONE_UK: 'Reino Unido *',
  ZONE_IT: 'Itália',
  ZONE_BE: 'Bélgica',
  ZONE_NL: 'Holanda',
  ZONE_LU: 'Luxemburgo',
  ZONE_GB: 'Reino Unido',
  ZONE_Ceuta: 'Ceuta',
  ZONE_Melilla: 'Melilla',
  ZONE_ANDORRA: 'Andorra',
  ZONE_GIBRALTAR: 'Gibraltar',
  ZONE_PTISLANDS: 'Ilhas Portugal',
  ZONE_PTIAEREO: 'Ilhas Portugal Aéreo',
  ZONE_PTIMARITIMO: 'Ilhas Portugal Marítimo',
  ZONE_CANMAY: 'Lpa - Tnf',
  ZONE_Portugal: 'Portugal',
  ZONE_TNFLPA: 'Tnf & Lpa',
  ZONE_IMENORES: 'I. Menores',
  ZONE_INTERI: 'Interilhas',
  ZONE_MALLORCA: 'Maiorca',
  ZONE_Madrid: 'Madrid',
  ZONE_ZONEA: 'Zona A',
  ZONE_ZONEB: 'Zona B',
  ZONE_ZONEC: 'Zona C',
  ZONE_ZONED: 'Zona D',
  ZONE_ZONEE: 'Zona E',
  ZONE_ZONEF: 'Zona F',
  ZONE_ZONEG: 'Zona G',
  ZONE_ZONEH: 'Zona H',
  ZONE_ZONEI: 'Zona I',
  ZONE_ZONES: 'Zona S',
  ZONE_ZONET: 'Zona T',
  ZONE_ZONEU: 'Zona U',
  ZONE_ZONEV: 'Zona V',
  ZONE_ZONEW: 'Zona W',
  ZONE_ZONEX: 'Zona X',
  ZONE_ZONEY: 'Zona Y',
  ZONE_Gibraltar: 'Gibraltar',
  ZONE_Andorra: 'Andorra',
  ZONE_TnfLpa: 'Tnf & Lpa',
  ZONE_IMenores: 'Outras Ilhas',
  ZONE_MesmaIlha: 'Mesma Ilha',
  ZONE_MesmoArquipelago: 'Mesmo Arquipélago',
  ZONE_EntreArquipelagos: 'Entre Arquipélagos',
  ZONE_Maiorca: 'Maiorca',
  ZONE_OutrasIlhas: 'Outras Ilhas',
  ZONE_Madeira: 'Madeira',
  ZONE_Açores: 'Açores',
  ZONE_PORTUGAL: 'Portugal',
  ZONE_SPAIN: 'Espanha',
  ZONE_MADEIRA: 'Madeira',
  ZONE_OTHER_ISLANDS: 'I. Menores',
  ZONE_INTERILHAS: 'Interilhas',
  ZONE_ARQUIPELAGOS: 'Arquipélagos',
  ZONE_AZORES_PT: 'Açores',
  ZONE_MAJORCA_PT: 'Maiorca',
  ZONE_OTHER_ISLANDS_PT: 'Outras Ilhas',
  ZONE_PORTUGAL_CONTINENTE: 'Portugal Continental',
  ZONE_ACORES: 'Açores',
  ZONE_CEUTA: 'Ceuta',
  ZONE_MELILLA: 'Melilla',
  ZONE_SPAIN_PT: 'Espanha',

  //NOTES
  NOTE_INSULAR: "<b>Nota:</b> Qualquer fluxo não constante nesta proposta comercial, pode ser disponibilizado ao cliente, sendo faturado de acordo com a tabela oficial de preços em vigor.",
  NOTE_PENINSULAR: "<b>Nota:</b> Qualquer fluxo não constante na proposta comercial, pode ser disponibilizado ao cliente, sendo faturado de acordo com a tabela oficial de preços em vigor.",

  // EXCEL EXPORT
  EXPORT_TO_EXCEL: 'Exportar para Excel',
  EXPORT_EXCEL_SUCCESS: 'Oferta exportada com sucesso para Excel',
  EXPORT_EXCEL_ERROR: 'Erro ao exportar a oferta para Excel',

  // EXCEL EXPORT - LABELS (ES/PT)
  EXCEL_TITLE_ES: 'OFERTA COMERCIAL CTT EXPRESS',
  EXCEL_TITLE_PT: 'OFERTA COMERCIAL CTT EXPRESS',
  EXCEL_INFO_GENERAL_ES: 'INFORMACIÓN GENERAL',
  EXCEL_INFO_GENERAL_PT: 'INFORMAÇÃO GERAL',
  EXCEL_PRODUCTS_PRICES_ES: 'PRODUCTOS Y PRECIOS',
  EXCEL_PRODUCTS_PRICES_PT: 'PRODUTOS E PREÇOS',
  EXCEL_PRODUCT_LABEL_ES: 'Producto:',
  EXCEL_PRODUCT_LABEL_PT: 'Produto:',
  EXCEL_OFFER_LABEL_ES: 'Oferta:',
  EXCEL_OFFER_LABEL_PT: 'Oferta:',
  EXCEL_WEIGHT_ES: 'Peso (kg)',
  EXCEL_WEIGHT_PT: 'Peso (kg)',
  EXCEL_ADDITIONAL_KG_ES: 'Kg Adicional',
  EXCEL_ADDITIONAL_KG_PT: 'Kg Adicional',
  EXCEL_NO_PRODUCTS_ES: 'No hay productos seleccionados',
  EXCEL_NO_PRODUCTS_PT: 'Não há produtos selecionados',
  EXCEL_PAYMENT_METHODS_ES: 'MÉTODOS DE PAGO',
  EXCEL_PAYMENT_METHODS_PT: 'MÉTODOS DE PAGAMENTO',
  EXCEL_SELECTED_METHOD_ES: 'Método Seleccionado:',
  EXCEL_SELECTED_METHOD_PT: 'Método Selecionado:',
  EXCEL_PAYMENT_DAY_ES: 'Día de Pago:',
  EXCEL_PAYMENT_DAY_PT: 'Dia de Pagamento:',
  EXCEL_ADDITIONAL_SERVICES_ES: 'SERVICIOS ADICIONALES',
  EXCEL_ADDITIONAL_SERVICES_PT: 'SERVIÇOS ADICIONAIS',
  EXCEL_SERVICE_POINTS_ES: 'PUNTOS DE SERVICIO',
  EXCEL_SERVICE_POINTS_PT: 'PONTOS DE SERVIÇO',
  EXCEL_ADDRESS_ES: 'Dirección',
  EXCEL_ADDRESS_PT: 'Endereço',
  EXCEL_CITY_ES: 'Ciudad',
  EXCEL_CITY_PT: 'Cidade',
  EXCEL_COMMITTED_SHIPMENTS_ES: 'Envíos Comprometidos',
  EXCEL_COMMITTED_SHIPMENTS_PT: 'Envios Comprometidos',
  EXCEL_FAVORITE_ES: 'Favorito',
  EXCEL_FAVORITE_PT: 'Favorito',
  EXCEL_BANK_DETAILS_ES: 'DATOS BANCARIOS',
  EXCEL_BANK_DETAILS_PT: 'DADOS BANCÁRIOS',
  EXCEL_IBAN_ES: 'IBAN:',
  EXCEL_IBAN_PT: 'IBAN:',
  EXCEL_IBAN2_ES: 'IBAN2 (Devoluciones):',
  EXCEL_IBAN2_PT: 'IBAN2 (Devoluções):',
  EXCEL_BANK_GUARANTEE_ES: 'GARANTÍA BANCARIA',
  EXCEL_BANK_GUARANTEE_PT: 'GARANTIA BANCÁRIA',
  EXCEL_AMOUNT_ES: 'Importe:',
  EXCEL_AMOUNT_PT: 'Montante:',
  EXCEL_TYPE_ES: 'Tipo:',
  EXCEL_TYPE_PT: 'Tipo:',
  EXCEL_DURATION_ES: 'Duración:',
  EXCEL_DURATION_PT: 'Duração:',
  EXCEL_ID_OFFER_ES: 'ID Oferta:',
  EXCEL_ID_OFFER_PT: 'ID Oferta:',
  EXCEL_CLIENT_ES: 'Cliente:',
  EXCEL_CLIENT_PT: 'Cliente:',
  EXCEL_CIF_ES: 'CIF:',
  EXCEL_CIF_PT: 'NIF:',
  EXCEL_CITY_GENERAL_ES: 'Ciudad:',
  EXCEL_CITY_GENERAL_PT: 'Cidade:',
  EXCEL_ADDRESS_GENERAL_ES: 'Dirección:',
  EXCEL_ADDRESS_GENERAL_PT: 'Endereço:',
  EXCEL_LEGAL_CITY_ES: 'Ciudad Jurídica:',
  EXCEL_LEGAL_CITY_PT: 'Cidade Jurídica:',
  EXCEL_COMMITTED_DELIVERIES_ES: 'Envíos Comprometidos:',
  EXCEL_COMMITTED_DELIVERIES_PT: 'Envios Comprometidos:',
  EXCEL_B2B_DIST_ES: 'Distribución B2B:',
  EXCEL_B2B_DIST_PT: 'Distribuição B2B:',
  EXCEL_B2C_DIST_ES: 'Distribución B2C:',
  EXCEL_B2C_DIST_PT: 'Distribuição B2C:',
  EXCEL_OFFER_TYPE_ES: 'Tipo de Oferta:',
  EXCEL_OFFER_TYPE_PT: 'Tipo de Oferta:',
  EXCEL_STATUS_ES: 'Estado:',
  EXCEL_STATUS_PT: 'Estado:',
  EXCEL_VALIDATION_STATUS_ES: 'Estado de Validación:',
  EXCEL_VALIDATION_STATUS_PT: 'Estado de Validação:',
  EXCEL_NOT_INCLUDED_ES: 'No incluido',
  EXCEL_NOT_INCLUDED_PT: 'Não incluído',
  EXCEL_YES_ES: 'Sí',
  EXCEL_YES_PT: 'Sim',
  EXCEL_NO_ES: 'No',
  EXCEL_NO_PT: 'Não',
  TX_CIES_EXP_GB: 'Gestão Aduaneira de Exportação (Reino Unido)',
  TX_CIES_REVERSAL: 'Tarifas de Reversão Aduaneira (em caso de devolução do envio)',
  TX_CIES_EXC_DIM: 'Suplemento de excesso de dimensões (120x600x60 até 200x120x80)',
  TX_CIES_DEMANDA: 'Taxa de Alta Procura para períodos de alta atividade',
  TX_CIES_AREAS_REMOTAS: 'Áreas remotas',
  TX_CIES_IMP_ADUANERO: 'Serviço de importação',
  TX_CIEL_SEG_VOLUNTARIO: 'Incremento de indemnização legal por perda ou roubo: Limite até 2.000 €/envio (lei 15/09 CTTM. Art.63). (Excluídas roturas, avarias que serão abonadas de acordo com o CMR)',
  TX_CIEL_DELIVERY_NOTE: 'Prova de entrega física',
  TX_CIEL_ENTREGA_ADICIONAL: 'Suplemento entrega adicional (mudança ou correção de morada e ausência do destinatário)',
  TX_CIEL_EXC_PESO_25: 'Suplemento para volumes do envio que excedam os 25 kg de peso real ou os 50 kg de peso volumétrico',
  TX_CIEL_EXC_PESO_50: 'Suplemento para volumes do envio que excedam os 50 kg de peso real ou os 70 kg de peso volumétrico',
  TX_CIEL_EXC_DIM_100: 'Suplemento aplicável quando qualquer medida supere >100 cm e <=120 cm',
  TX_CIEL_EXC_DIM_120: 'Suplemento aplicável quando qualquer medida supere <120 cm e <=175 cm',
  TX_CIEL_EXC_DIM_175: 'Suplemento aplicável quando qualquer medida supere >175 cm',
  TX_CIEL_EXC_DIM_SUM: 'Suplemento excesso de soma de medidas por volume (alto+largo+comprimento) superior a 250 cm',
  TX_CIEL_SPECIAL_HANDLING: 'Manipulação Especial',
  TX_CIEL_EXC_ITEM: 'Suplemento por volume ou paletes não empilháveis',
  TX_CIEL_HIELO_SECO: 'Gelo seco < 20 Kg',
  TX_CIEL_EXC_HIELO_SECO: 'Gelo seco > 20 Kg',
  TX_CIEL_AREAS_REMOTAS: 'Áreas remotas',
  TX_CIEL_SERVICIO_ISLAS: 'Serviço Ilhas (suplemento para envios com destino a ilhas não especificamente incluídas como zona)',
  TX_CIEL_EXP_FUERA_EU: 'Trâmite exportação (envios com valor >150 € com destino fora da União Europeia)',
  TX_CIEL_EXP_GB: 'Taxa administrativa de alfândega - Reino Unido',
  TX_CIEL_DUTY: 'Direitos aduaneiros',
  TX_CIEL_PEAK: 'Taxa de Alta Procura para períodos de alta atividade',
}
